module.exports = __webpack_public_path__ + "img/logo-horizontal-1.ff064396.svg";